<template>
  <div class="text-field-response">
    <div class="field-header">
      <h3 class="field-label">
        {{ field.label }}
        <span v-if="field.required" class="required-indicator">*</span>
      </h3>
    </div>

    <div v-if="field.description" class="field-description">
      {{ field.description }}
    </div>

    <v-text-field
      v-model="localResponse.textValue"
      outlined
      dense
      :readonly="disabled"
      :placeholder="field.hint || 'Enter text...'"
      :rules="disabled ? [] : getValidationRules()"
      @change="updateResponse"
    ></v-text-field>

    <v-textarea
      v-model="localResponse.comment"
      outlined
      dense
      :readonly="disabled"
      label="Comment (Optional)"
      placeholder="Add any additional comments here..."
      rows="2"
      auto-grow
      @change="updateResponse"
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: 'TextFieldResponse',
  props: {
    field: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    response: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      localResponse: {
        fieldId: 0,
        textValue: '',
        comment: ''
      }
    }
  },
  watch: {
    response() {
      this.initializeResponse();
    }
  },
  created() {
    this.initializeResponse();
  },
  methods: {
    initializeResponse() {
      if (this.response) {
        this.localResponse = { ...this.response };
      } else {
        this.localResponse = {
          fieldId: this.field.id || 0,
          textValue: '',
          comment: ''
        };
      }
    },
    getValidationRules() {
      const rules = [];

      if (this.field.required) {
        rules.push((v) => !!v || `${this.field.label} is required`);
      }

      if (this.field.minLength !== undefined) {
        rules.push((v) => !v || v.length >= this.field.minLength ||
          `Minimum length is ${this.field.minLength} characters`);
      }

      if (this.field.maxLength !== undefined) {
        rules.push((v) => !v || v.length <= this.field.maxLength ||
          `Maximum length is ${this.field.maxLength} characters`);
      }

      return rules;
    },
    updateResponse() {
      console.log("Yeah")
      this.$emit('update:response', this.localResponse);
    }
  }
}
</script>

<style scoped>
.text-field-response {
  width: 100%;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.field-label {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  margin: 0 0 4px 0;
}

.required-indicator {
  color: #f44336;
  margin-left: 4px;
}

.field-description {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
}
</style>
